import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=40a59b86&scoped=true&"
import script from "./RealEstate.vue?vue&type=script&lang=ts&"
export * from "./RealEstate.vue?vue&type=script&lang=ts&"
import style0 from "./RealEstate.vue?vue&type=style&index=0&id=40a59b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a59b86",
  null
  
)

export default component.exports